import Vue from 'vue'
import Element from 'element-ui'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
import zhLocale from './zh'
import enLocale from './en'
import deLocale from './de'
import jpnLocale from './jpn'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementDeLocale from 'element-ui/lib/locale/lang/de'
import elementJaLocale from 'element-ui/lib/locale/lang/ja'

// console.log(enLocale)
let language = localStorage.getItem('language')
console.log(language)
const i18n = new VueI18n({
    locale:language,
    messages: {
        zh: {
            ...zhLocale,
            ...elementZhLocale // 或者用 Object.assign({ message: '你好' }, zhLocale)
        },
        en: {
            ...enLocale,
            ...elementEnLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
        },
        de: {
            ...deLocale,
            ...elementDeLocale
        },
        ja: {
            ...jpnLocale,
            ...elementJaLocale
        }
    }


})

export default i18n